import controller from './featured-products.controller';
import templateBase from './templates/featured-products-base.view.html';

let FeaturedProductsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    //let response = SessionService.get('components');

    /*if (response.BY_FAVORITES.component == 'template_t1') {
        return templateT1;
    } else {*/
    return templateBase;
    //}
}

export default FeaturedProductsComponent;



// WEBPACK FOOTER //
// ./www/components/catalog/featured-products/featured-products.component.js